import React from 'react';

import { Route, Switch, Redirect } from 'react-router-dom';
import CV from './views/CV';
import Contact from './views/Contact';
import Header from './Header';
import News from './views/News';
import WorkList from './views/WorkList';
import WorkDetail from './views/WorkDetail';

class PyovsPyo extends React.Component {

  state = {
    menuVisible: false
  }

  handleNavToggle = () => {
    this.setState({
      menuVisible: !this.state.menuVisible
    })
  }

  render() {
    return (
      <>
        <Header
          handleNavToggle={this.handleNavToggle}
        />
        <div className="">
          <div className="main-pyovspyo">
              <Switch>
                <Route path="/work/:id" component={WorkDetail}>
                </Route>
                <Route path="/work">
                  <WorkList/>
                </Route>
                <Route path="/news">
                  <News/>
                </Route>
                <Route path="/cv">
                  <CV/>
                </Route>
                <Route path="/contact">
                  <Contact/>
                </Route>
                <Route path="/work">
                  <WorkList/>
                </Route>
                <Route path="/">
                  <Redirect to="/work" />
                </Route>
              </Switch>
          </div>
        </div>
        {/* <div className={"sidenav-overlay " + (this.state.menuVisible ? "active" : "")}></div> */}
      </>
    );
  }
}

export default PyovsPyo;